<template>
	<div class="customFixed-vue alertPOP darkFadeBG appCustimTime">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<div class="mainContent customTime">
	    		<div class="topSettingHead position-relative border-bottom p-3">
	    			<p class="f-14 mb-0">{{$t('date_range')}}:</p>
					<span class="closePOP" @click.prevent="$parent.customTime = false"><feather size="13px" type="x"></feather></span>
	    		</div>
	    		<div class="mainTab-onea p-4">
		    	<form class="updateWrap">
		    		<div class="formSelect-date">
						<form class="updateWrap">
							<div class="twoColmn">
								<div class="form-fields">
									<p class="mb-1">{{$t('from')}} {{$parent.FROM_DATE}}</p>
									<input type="date" v-model="$parent.FROM_DATE" :max="fromMax()"><!--  :min="2000-01-02" -->
									<div class="fromTO mt-3">
										<p class="mb-2">{{$t('to')}} {{$parent.TO_DATE}}</p>
										<input type="date" v-model="$parent.TO_DATE" :max="future" :min="$parent.FROM_DATE">
									</div>
								</div> 
							</div>
							
						</form>
					</div>
					<div class="fullWidh w-100 text-center my-4">
						<a href="#" class="btn appButton linkBG mx-auto justify-content-center large" @click.prevent="submit()">{{$t('submit')}}</a>
					</div>
				</form>
			    </div>
	    	</div>
	    </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    name: 'alert-pop',
    data() {
        return {
        	future : moment().format('YYYY-MM-DD')
        }
    },
    methods:{
    	fromMax(){
    		if(this.$parent.TO_DATE){
    			return this.$parent.TO_DATE
    		}else{
    			return this.future
    		}
    	},
    	submit(){
    		this.$emit('changeTime');
    	}
    },
    mounted() {
		const _that = this
        /*$(document).on("click", function(event){
			if(!$(event.target).closest('.openHeader').length){
                // _that.openHeader = false
            }
        });*/
	}
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/order/app-custom-time.vue